import axios from 'axios';
import _ from 'lodash';
import * as types from '../constants/ActionTypes';

function requestTopicTree() {
  return {
    type: types.REQUEST_TOPIC_TREE,
    payload: undefined,
  };
}


function receiveTopicTree(response, experience) {
  const topics = _.get(response, 'webTopicTree');
  return {
    type: types.RESPONSE_TOPIC_TREE,
    payload: {
      topics,
      experience,
    },
  };
}
function receiveTopicTreeError() {
  return {
    type: types.ERROR_TOPIC_TREE,
    payload: undefined,
  };
}

export default function fetchTopicTree(experience) {
  return (dispatch) => {
    dispatch(requestTopicTree());
    return axios.get('/smarthelp/web-topic-tree')
      .then(response => dispatch(receiveTopicTree(response.data, experience)))
      .catch(() => {
        dispatch(receiveTopicTreeError());
      });
  };
}



// WEBPACK FOOTER //
// ./home/actions/action-topic-list.js